import { createSlice } from "@reduxjs/toolkit";
import { updateAccDetailAPI } from "../../../api/publicApi";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const updateAccDetailSlice = createSlice({
  name: "updateAccDetail",
  initialState: data,
  reducers: {
    updateAccDetailSlice(state) {
      state.isLoading = true;
    },
    updateAccDetailSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    updateAccDetailSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    updateAccDetailSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const updateAccDetailHandler = (user_id:string,data:any) => async (dispatch: any) => {
  try {
    dispatch(updateAccDetailAction.updateAccDetailSlice());
    const response: any = await updateAccDetailAPI(user_id,data);
    dispatch(updateAccDetailAction.updateAccDetailSliceSuccess(response));
    typeof localStorage !=="undefined"&&localStorage.setItem("username",response?.results?.screen_name);
    typeof localStorage !=="undefined"&&localStorage.setItem('userId', response?.results?.id);
    typeof localStorage !=="undefined"&&localStorage.setItem('role', response?.results?.type);
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(updateAccDetailAction.updateAccDetailSliceFailure(e?.response?.data?.message));
    dispatch(updateAccDetailAction.updateAccDetailSliceReset());
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default updateAccDetailSlice.reducer;
export const updateAccDetailAction = updateAccDetailSlice.actions;
